import moment from "moment-timezone";

/**
 * Sort array by date according to order passed
 * @param {Date String} a
 * @param {Date String} b
 * @param {String} ORDER ['ASC', DESC]
 * @returns Sorted array by date
 */
export const sortByDate = (a, b, ORDER) => {
	const firstDate = moment(a?.dateData);
	const nextDate = moment(b?.dateData);

	const isASC = ORDER === "ASC";

	return isASC
		? firstDate.valueOf() - nextDate.valueOf()
		: nextDate.valueOf() - firstDate.valueOf();
};
